import React from 'react'
import { connect } from 'react-redux'
import { reduxForm, getFormValues, Field, SubmissionError } from 'redux-form'
import { Button } from 'semantic-ui-react'
import { Dialog, DialogTitle, DialogContent, DialogActions } from '@material-ui/core'
import FieldInput, { InputType as type } from 'components/SemanticForm'
import { AddBankContainer } from './styled'
import { validations, validateCase as vCase } from 'core/validate'
import { getBankBranch } from 'ducks/options'

const VendorBankModal = (props) => {
  const { valueForm, change, handleSubmit, onSubmitBank, showVendorBankModal, bankData, clearBankData,
    listBank, countries, bankKeys, bankBranch } = props
  const isNew = bankData ? false : true
  const bankKeyOptions = valueForm.bankCountry ? bankKeys.data.filter(b => b.country === valueForm.bankCountry) : bankKeys.data

  const submitBank = () => {
    var accountNumberDuplicate = false
    if (isNew) {
      var b = listBank.find(b => b.accountNumber === valueForm.accountNumber)

      if (b) accountNumberDuplicate = true
    } else {
      if (bankData.accountNumber !== valueForm.accountNumber) {
        // Change account number
        var bank = listBank.find(b => b.accountNumber === valueForm.accountNumber)
        if (bank) accountNumberDuplicate = true
      }
    }

    if (!accountNumberDuplicate) {
      onSubmitBank(valueForm, isNew, bankData)
      if (!isNew) clearBankData()
      showVendorBankModal(false)
    } else {
      throw new SubmissionError({ accountNumber: 'This account number is not available!' })
    }
  }

  React.useEffect(() => {
    let editData = bankData || {}

    if (editData.bankKey) {
      if (bankBranch.data[editData.bankKey] === undefined) {
        props.getBankBranch(editData.bankKey)
      }
    }
  }, [])

  const onSelectBankKey = (bankKey) => {
    change('branch', '')
    if (bankBranch.data[bankKey] === undefined) {
      props.getBankBranch(bankKey)
    }
  }

  return (
    <Dialog open={true} maxWidth='sm' fullWidth style={{ zIndex: 10 }}>
      <DialogTitle>Bank Account Details</DialogTitle>
      <DialogContent>
        <form>
          <AddBankContainer>
            <div className='rowFields'>
              <Field
                name='bankCountry'
                label='Bank Country'
                require
                type={type.select}
                options={countries.data}
                component={FieldInput} />
              <Field
                name='bankKey'
                label='Bank Key'
                require
                type={type.select}
                options={bankKeyOptions}
                specialOnChange={(bankKey) => onSelectBankKey(bankKey)}
                component={FieldInput} />
            </div>
            <div className='rowFields'>
              <Field 
                name='branch' 
                label='Branch' 
                require 
                loading={bankBranch.loading}
                options={bankBranch.data[valueForm.bankKey] || []}
                type={type.select} 
                component={FieldInput} 
              />
            </div>
            <div className='rowFields'>
              <Field 
                name='accountNumber' 
                label='Account Number' 
                require 
                type={type.text} 
                component={FieldInput} 
              />
            </div>
            <div className='rowFields'>
              <Field 
                name='accountName' 
                label='Account Name' 
                require 
                type={type.text} 
                component={FieldInput} 
              />
            </div>
          </AddBankContainer>
        </form>
      </DialogContent>
      <DialogActions>
        <form onSubmit={handleSubmit(values => submitBank())}>
          <Button
            color='blue'
            content={isNew ? 'Add' : 'Save'}
            type='submit'
          />
          <Button
            color='red'
            content='Cancel'
            onClick={() => {
              clearBankData()
              showVendorBankModal(false)
            }}
          />
        </form>
      </DialogActions>
    </Dialog>
  )
}

const mapStateToProps = (state, props) => {
  const bankData = props.bankData || {}
  const country = props.country || ''
  return ({
    valueForm: getFormValues('formVendorBank')(state) || {},
    initialValues: {
      id: bankData.id || null,
      sapId: bankData.sapId || '',
      bankCountry: bankData.bankCountry || country,
      bankKey: bankData.bankKey || '',
      branch: bankData.branch || '',
      accountNumber: bankData.accountNumber || '',
      accountName: bankData.accountName || '',
      index: bankData.index || null
    },
    countries: state.options.countries,
    bankKeys: state.options.bankKeys,
    bankBranch: state.options.bankBranch,
  })
}
  
const mapDispatchToProps = {
  getBankBranch
}

const validate = (values) => {
  let errors = {}
  validations(values, 'bankCountry', [vCase.require], errors)
  validations(values, 'bankKey', [vCase.require], errors)
  validations(values, 'branch', [vCase.require], errors)
  validations(values, 'accountNumber', [vCase.require, vCase.digit, vCase.maxLength18], errors)
  validations(values, 'accountName', [vCase.require, vCase.maxLength60], errors)

  return errors
}

const VendorBankForm = reduxForm({
  form: 'formVendorBank',
  enableReinitialize: true,
  validate
})(VendorBankModal)

export default connect(mapStateToProps, mapDispatchToProps)(VendorBankForm)